import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import { Formik, Field, Form } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import Overlay from "../../../components/Overlay";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import "./forgotstyle.css";
import jobDashLogo from "../../../assets/images/jobDashlogo.png";
import axios from "../../../axios";
import { IoArrowBackOutline } from "react-icons/io5";

// --- OTP Validator ---
const otpValidator = (values) => {
  const errors = {};
  const otp = values.otp.join("");

  if (otp.length !== 4) {
    errors.otp = "OTP must be 4 digits";
  }
  return errors;
};

const useStyles = makeStyles((theme) => ({
  formStyle: {
    width: "100%",
    // padding: "2rem",
    overflow: "scroll",
  },
}));

const OtpVerify = ({ setUsers, userData }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const formikRef = React.useRef();

  // Read otpData from localStorage
  const otpData = JSON.parse(localStorage.getItem("otpData") || "{}");
  const userId = otpData?.userId; // comes from localStorage.otpData

  const email = location?.state?.email || otpData?.email; // fallback to localStorage if needed

  const [isLoading, setIsLoading] = useState(false);
   const [timer, setTimer] = useState(60);
  const [isDisabled, setIsDisabled] = useState(true);
  // const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    otp: ["", "", "", ""],
  };

  const handleVerifyOtp = async (values) => {
    setIsLoading(true);

    const finalOtp = values.otp.join("");

    // Optional: basic guard
    if (!userId) {
      toast.error("User ID missing. Please try again.", {
        position: "top-right",
      });
      setIsLoading(false);
      return;
    }

    try {
      // Include _id from userId in payload
      const payload = {
        otp: finalOtp,
        _id: userId,
      };
      console.log("payload  payload payload", payload)

      const response = await axios.post("/verifyOtp", payload);

      if (response?.status === 200) {
        toast.success("OTP verified successfully!", { position: "top-right" });

        navigate("/confirmPassword", {
          state: { email }, // we already have email
        });
      }
    } catch (error) {
      
      const status = error?.response?.status;

      if (status === 422) {
        console.log("object,error", error)
        toast.error(
          error?.response?.data?.errors?.[0]?.msg || "Validation error",
          {
            position: "top-right",
          }
        );
      } 
      else {
        toast.error(
          error?.response?.data?.message,
          {
            position: "top-right",
          }
        );
      }
    } finally {
      setIsLoading(false);
    }
  };






  useEffect(() => {
    let interval;

    if (isDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setIsDisabled(false);
    }

    return () => clearInterval(interval);
  }, [timer, isDisabled]);

  // ----------------------------
  // API CALL ON RESEND OTP
  // ----------------------------
  // const handleResendOtp = async () => {
  //   setIsLoading(true);

  //   try {
  //     const response = await axios.get(`/resendOtp/${userId}`);

  //     if (response?.status === 200) {
  //       toast.success("OTP sent successfully!", { position: "top-right" });

  //       // restart timer
  //       setIsDisabled(true);
  //       setTimer(60);

  //       // optional navigation
  //       navigate("/otpVerify", {
  //         state: { email },
  //       });
  //     }
  //   } catch (error) {
  //     const status = error?.response?.status;

  //     if (status === 422) {
  //       toast.error(
  //         error?.response?.data?.errors?.[0]?.msg || "Validation error",
  //         { position: "top-right" }
  //       );
  //     } else {
  //       toast.error(
  //         error?.response?.data?.message || "Something went wrong",
  //         { position: "top-right" }
  //       );
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleResendOtp = async () => {
  setIsLoading(true);

  try {
    const response = await axios.get(`/resendOtp/${userId}`);

    if (response?.status === 200) {
      toast.success("OTP sent successfully!", { position: "top-right" });

      // Clear OTP fields
      formikRef.current?.setValues({ otp: ["", "", "", ""] });

      // restart timer
      setIsDisabled(true);
      setTimer(60);

      navigate("/otpVerify", {
        state: { email },
      });
    }
  } catch (error) {
    const status = error?.response?.status;

    if (status === 422) {
      toast.error(
        error?.response?.data?.errors?.[0]?.msg || "Validation error",
        { position: "top-right" }
      );
    } else {
      toast.error(
        error?.response?.data?.message || "Something went wrong",
        { position: "top-right" }
      );
    }
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <section className="auth">
        <div className="login">
          <div className="login-text-cant">
            <img
              src={jobDashLogo}
              style={{ height: "75.78px", width: "97px" }}
            />
          </div>

          <div className="logincontainer">
            <div className="login-main-cant">
              <div className="form">
                <Formik
                 innerRef={formikRef}
                  enableReinitialize
                  initialValues={initialValues}
                  validate={otpValidator}
                  validateOnChange
                  onSubmit={handleVerifyOtp}
                >
               
                  {(formikBag) => (
                    <Form className={classes.formStyle}>
                      <label className="lableHeadingotp">Enter 4 Digit OTP</label>

                      <div
                        className="otp-container"
                        style={{
                          display: "flex",
                          gap: "10px",
                          marginTop: "10px",
                        }}
                      >
                        {[0, 1, 2, 3].map((index) => (
                          <Field key={index} name={`otp[${index}]`}>
                            {({ field }) => (
                              <input
                                {...field}
                                type="text"
                                maxLength={1}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="otp-box"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  fontSize: "22px",
                                  textAlign: "center",
                                  borderRadius: "8px",
                                  border: "1px solid #ccc",
                                }}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, "");
                                  formikBag.setFieldValue(`otp[${index}]`, value);

                                  if (value && index < 3) {
                                    document
                                      .getElementById(`otp-${index + 1}`)
                                      .focus();
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" &&
                                    !formikBag.values.otp[index] &&
                                    index > 0
                                  ) {
                                    document
                                      .getElementById(`otp-${index - 1}`)
                                      .focus();
                                  }
                                }}
                                id={`otp-${index}`}
                              />
                            )}
                          </Field>
                        ))}
                      </div>

                      <p className="errorData">
                        {formikBag.errors.otp ? formikBag.errors.otp : ""}
                      </p>

                      {/* <div className="resendOTP">Resend OTP</div>  */}
                      <div
                        className="resendOTP"
                        onClick={!isDisabled ? handleResendOtp : undefined}
                        style={{
                          pointerEvents: isDisabled ? "none" : "auto",
                          opacity: isDisabled ? 0.5 : 1,
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          // fontWeight: "bold",
                        }}
                      >
                        {isDisabled ? `Resend OTP : ${timer}s` : "Resend OTP"}
                      </div>

                      <button type="submit">Verify OTP</button>
                    </Form>
                  )}
                </Formik>
              </div>

              <div
                className="forgotText"
                onClick={() => navigate("/")}
              >
                <IoArrowBackOutline /> Back to login page
              </div>
            </div>
          </div>
        </div>

        {isLoading && <Overlay />}
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.userData,
  locationData: state.locations,
  defaultState: state.defaultState,
});

const mapDispatchToProps = (dispatch) => ({
  setUsers: (updatedValue) =>
    dispatch({ type: actionTypes.UPDATE_USER, updatedUser: updatedValue }),

  setDefaultState: (updatedValue) =>
    dispatch({ type: actionTypes.UPDATE_DEFAULT, updateDefault: updatedValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerify);

